import { ATTACHMENT_BOUNDARY_PATH_PREFIX } from "../../common/constants";

export const BUG_REPORT_ROUTE_PREFIX = "/bug-reports";

export const BUG_REPORT_ROUTE_PATHS = {
  attachment: { to: `${ATTACHMENT_BOUNDARY_PATH_PREFIX}${BUG_REPORT_ROUTE_PREFIX}/:id1/attachments/:id2` },
};
